// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/dashboard/Dashboard.css
// module id = 2005
// module chunks = 0